import { render, staticRenderFns } from "./pending.vue?vue&type=template&id=2b201132&scoped=true"
import script from "./pending.vue?vue&type=script&lang=js"
export * from "./pending.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b201132",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b201132')) {
      api.createRecord('2b201132', component.options)
    } else {
      api.reload('2b201132', component.options)
    }
    module.hot.accept("./pending.vue?vue&type=template&id=2b201132&scoped=true", function () {
      api.rerender('2b201132', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/fd/examine/pending.vue"
export default component.exports